import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from "@angular/core";
import { PassKeyRenameSuccessComponent } from "./pass-key-rename-success.component";


class PasskeyRenameSuccessFormSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;
    isSuccess: boolean;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    resolver: ComponentFactoryResolver;
    viewContainerRef: ViewContainerRef;
    passKeyRenameSuccessComponentRef: ComponentRef<PassKeyRenameSuccessComponent>;

    constructor(formId: string, payload: object) {
        console.log('Inside pass key rename success form constructor');
        this.formId = formId;
        this.payload = payload;
        this.isSuccess = payload['success'];
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        console.log('Pass Key Rename Success Form session started: ' + this.formId);
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.resolver = (clientContext as any).resolver;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
        console.log('Pass Key Rename Success Form session ended: ' + this.formId);
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        console.log('Pass Key Rename Success Form session Input: ' + this.formId);
        const self = this;
        self.viewContainerRef.clear();
        const factory: ComponentFactory<PassKeyRenameSuccessComponent> = self.resolver.resolveComponentFactory(PassKeyRenameSuccessComponent);
        self.passKeyRenameSuccessComponentRef = self.viewContainerRef.createComponent(factory);
        self.passKeyRenameSuccessComponentRef.instance.isSuccess = this.isSuccess;

        console.log('pass key rename success form constructor payload:', this.payload);

        return new Promise((resolve, reject) => {
          self.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
              console.log('pass key rename success form createFormInputSubmissionRequest SUCCESS payload: ', payload);
              self.submitBlock = null;
            } catch (e) {
              console.log('pass key rename success form createFormInputSubmissionRequest ERROR payload: ', payload);
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
        console.log('pass key rename success form onContinue for ' + this.formId + ' payload:', payload);
      }

      onError(payload: object): void {
        console.log('pass key rename success form onError for ' + this.formId + ' payload:', payload);
      }

}

interface ActionsInPayload {
    [key: string]: any;
  }

export default PasskeyRenameSuccessFormSession;
